<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12 module-title">GEPRODUCEERD</div>
      <div class="col-lg-12" v-if="debug">
        <div class="product-info">
          {{debug}}
        </div>
      </div>
      <div class="col-lg-12">
        <div class="product-info" v-if="items.length === 0 && fetchingItems.length === 0">
          Scan een barcode om aan te geven dat een item geproduceerd is. Je kan meerdere barcodes achter elkaar scannen.
        </div>
        <div class="product-info" v-else>
          <table>
            <tr>
              <td class="text-left text-totals">{{items.length + fetchingItems.length}} totaal</td>
              <td class="text-right text-totals">{{items.length - numErrors}} gescand</td>
            </tr>
            <tr>
              <td class="text-left text-totals">{{numScannedTwice}} dubbel</td>
              <td class="text-right text-totals">{{numErrors}} fouten</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="product-info" v-for="barcode in fetchingItems">
          <span class="item-loader float-left"></span> Verwerken {{barcode}}
        </div>
        <div class="product-info" v-for="item in items">
          <table>
            <tr>
              <td v-if="item.error"><span class="badge badge-production-status badge-error">Error</span> {{item.barcode}}</td>
              <td v-else><span v-html="getProductionStatusBadge(item.item)"></span> {{item.barcode}}</td>
            </tr>
            <tr>
              <td v-if="item.error">{{item.error}}</td>
              <td v-else>{{item.item.product.productName}} {{item.item.variation.variationName}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EB from 'EB'

  const barcodeOptions = {
    allDecoders: false,
    code128: true,
    code128securityLevel: 0,
    code39: true,
    code39securityLevel: 0,
    datamatrix: true,
    aimType: EB.Barcode.AIMTYPE_CONTINUOUS_READ, // AIMTYPE_TRIGGER
    decodeFrequency: 2000,
    decodeLEDFeedback: true,
    decodeLEDFeedbackMode: EB.Barcode.LEDMODE_BOTH,
    decodeLEDTime: 300,
    decodeVolume: 5,
    decodeDuration: 200,
    hapticFeedback: true,
    lcdMode: true,
    sameSymbolTimeout: 500,
    differentSymbolTimeout: 0
  }

  export default {
    created () {
      if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
        this.scannerType = 'zebra'

        EB.Barcode.enable(barcodeOptions, this.zebraBarcodeScanned)
        EB.Application.setApplicationNotify(this.onZebraApplicationDestroy)
      } else {
        this.scannerType = 'software'
      }
    },
    beforeDestroy () {
      if (window.navigator.userAgent.match(/ TC7[05]x? /)) {
        EB.Barcode.disable()
      }
    },
    data () {
      return {
        items: [],
        fetchingItems: [],
        scannerType: null,
        debug: null,
        numScannedTwice: 0
      }
    },
    computed: {
      numErrors: function () {
        let numErrors = 0

        for (let item of this.items) {
          if (item.error) {
            numErrors++
          }
        }

        return numErrors
      }
    },
    methods: {
      onZebraApplicationDestroy: function (event) {
        switch (event.applicationEvent) {
          case EB.Application.APP_EVENT_ACTIVATED:
          case EB.Application.APP_EVENT_UICREATED:
          case EB.Application.APP_EVENT_SCREEN_ON:
            EB.Barcode.enable(barcodeOptions, this.zebraBarcodeScanned)
            break
          case EB.Application.APP_EVENT_SCREEN_OFF:
          case EB.Application.APP_EVENT_UIDESTROYED:
          case EB.Application.APP_EVENT_DEACTIVATED:
            EB.Barcode.disable()
            break
        }
      },
      zebraBarcodeScanned: function (barcode) {
        this.changeItemStatus(barcode.data)
      },
      changeItemStatus: function (barcode) {
        // check if the barcode is already scanned this session
        for (let fetchingBarcode of this.fetchingItems) {
          if (fetchingBarcode === barcode) {
            this.numScannedTwice++
            return
          }
        }

        for (let x in this.items) {
          if (this.items[x].barcode === barcode) {
            let removed = this.items.splice(x, 1)

            for (let reAdd of removed) {
              this.items.unshift(reAdd)
            }

            this.numScannedTwice++
            return
          }
        }

        this.fetchingItems.push(barcode)
        this.updateProductionStatus({
          barcode: barcode,
          attempt: 0
        })
      },
      updateProductionStatus: function (info) {
        this.$http.patch(process.env.API_URL + '/production-receipt/' + info.barcode + '/production-status', {
          productionStatus: 'produced'
        }).then(response => {
          for (let x in this.fetchingItems) {
            if (this.fetchingItems[x] === info.barcode) {
              this.fetchingItems.splice(x, 1)
            }
          }

          this.items.unshift({
            barcode: info.barcode,
            item: response.body
          })
        }, response => {
          if (response.status === 0) {
            if (info.attempt < 3) {
              setTimeout(() => {
                this.updateProductionStatus({
                  barcode: info.barcode,
                  attempt: info.attempt + 1
                })
              }, 3000 * (info.attempt + 1))

              return
            }
          }

          for (let x in this.fetchingItems) {
            if (this.fetchingItems[x] === info.barcode) {
              this.fetchingItems.splice(x, 1)
            }
          }

          let error = 'Er heeft zich een onbekende fout voorgedaan'

          if (response.status === 0) {
            error = 'Kan geen informatie ophalen vanaf de server, controleer de internetverbinding.'
          } else if (response.status === 404) {
            error = 'Geen informatie gevonden voor ' + info.barcode + '.'
          } else if (response.status === 412) {
            error = response.body.errors.join(', ')
          }

          this.items.unshift({
            barcode: info.barcode,
            error: error
          })
        })
      },
      getProductionStatusBadge: function (item) {
        switch (item.productionStatus) {
          case 'new':
            return '<span class="badge badge-production-status badge-new">Nieuw</span>'
          case 'cancelled':
            return '<span class="badge badge-production-status badge-cancelled">Geannuleerd</span>'
          case 'preparing_for_production':
          case 'in_production':
            return '<span class="badge badge-production-status badge-in-production">In productie</span>'
          case 'produced':
            if (item.packingStatus === 'packed') {
              return '<span class="badge badge-production-status badge-packed">Ingepakt</span>'
            }

            return '<span class="badge badge-production-status badge-produced-scan">Geproduceerd</span>'
          default:
            return item.productionStatus
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  a:hover {
    cursor: pointer;
  }

  .module-title {
    background-color: #ff8535;
    color: #fff;
    font-size: 20px;
    line-height: 40px;
    margin-bottom: 15px;
  }

  .product-info {
    background-color: #fff;
    margin-bottom: 15px;
    padding: 10px;
    width: 100%;
  }

  .product-info table {
    width: 100%;
  }

  .product-info table td {
    vertical-align: top;
  }

  .product-info .badge {
    vertical-align: text-bottom;
  }

  .text-left {
    text-align: left;
  }

  .text-center {
    text-align: center;
  }

  .text-right {
    text-align: right;
  }

  .text-totals {
    width: 33.333%;
  }
</style>



// WEBPACK FOOTER //
// src/components/ScanProduced.vue